// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomerAddNote_wrapper__bG1KO"};